"use strict";

module.exports = function (accumulator, order, product, component) {
  var addition;

  if (component.guest_addressing) {
    addition = '-GuestAddressing';
  } else if (component.return_addressing) {
    addition = '-ReturnAddressing';
  } else {
    addition = '-Blank Envelopes';
  }

  return accumulator + addition;
};